<template>
    <div>
        <Panel 
            title="Lagerstatus" 
            :action="item.stock_count_reserved > 0 ? 'Vis sager med reservede varer' : ''"
            @click="onOpenProjectModal"
        >
            <table class="table is-fullwidth">
                <tbody>
                <tr>
                    <td>Min. antal</td>
                    <td class="w-auto">
                        {{ item.min_stock }}
                    </td>
                </tr>
                <tr>
                    <td>På lager i alt</td>
                    <td>{{ item.stock_count_total }}</td>
                </tr>
                <tr>
                    <td>Reserverede</td>
                    <td>{{ item.stock_count_reserved }}</td>
                </tr>
                <tr>
                    <td>Tilgængelige</td>
                    <td>{{ item.stock_count_total-item.stock_count_reserved }}</td>
                </tr>
                </tbody>
            </table>
        </Panel>

        <ItemProjectModal
            :active="showItemProjectModal"
            :item="item"
            @closed="onCloseProjectModal"
        />

        <Panel title="Varer fordelt på Lokationer" action="Tilknyt lokation" @click="onOpenLocationModal" v-if="item.type.key!='with_serial'">
            <table class="table is-fullwidth">
                <tbody>
                <tr>
                    <td><u>Lokation</u></td>
                    <td class="count-width"><u>Antal</u></td>
                    <td class="pr-4"><u>Reserveret</u></td>
                    <td></td>
                </tr>
                <tr v-for="itemLocation in item.itemLocations" :key="itemLocation.id">
                    <td>{{ itemLocation.location.full_name }}</td>
                    <td>
                        <div v-if="selectedItemLocationId !== itemLocation.id" class="count">
                            <p @click.prevent="edit(itemLocation)">{{ itemLocation.count }}</p>
                        </div>
                        <div v-else>
                            <InputText :ref="'item-location-' + itemLocation.id"
                                :value="itemLocation.count"
                                type="number"
                                @keyup.enter="onUpdateKeyUpEnter"
                                @blur="update(itemLocation, $event)"/>
                        </div>
                    </td>
                    <td>
                        {{ itemLocation.reserved }}
                    </td>
                    <td style="text-align: right;">
                        <a class="button is-small" title="Slet" @click.prevent="remove(itemLocation)">
                            <span class="icon"><i class="fas fa-trash-alt"/></span>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>

            <ItemLocationModal
                :active="showItemLocationModal"
                :item="item"
                @closed="onCloseLocationModal"
                @created="onCreated"
            />
        </Panel>
    </div>
</template>

<script>
import Panel from "@elems/Panel";
import PageHeader from "@elems/pageHeader";
import ItemLocationModal from "../forms/ItemLocationModal";
import ItemProjectModal from "../forms/ItemProjectModal";
import FormField from "@elems/form/FormField";
import InputText from "@elems/form/InputText";

export default {
    components: { InputText, FormField, ItemLocationModal, ItemProjectModal, PageHeader, Panel },
    props: {
        item: {
            type: Object,
            required: true,
        },
        showAdminFields: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showItemLocationModal: false,
            showItemProjectModal: false,
            selectedItemLocationId: null,
        };
    },
    computed: {
        apiUrl() {
            return `/api/item-locations`;
        }
    },
    methods: {
        edit(itemLocation) {
            this.selectedItemLocationId = itemLocation.id;
            this.$nextTick(() => {
                const inputs = this.$refs['item-location-' + itemLocation.id];
                if (inputs.length) {
                    inputs[0].$el.focus();
                }
            })
        },
        remove(itemLocation) {
            if (!confirm('Er du sikker på du vil slette?')) {
                return
            }

           window.axios.delete(`${this.apiUrl}/${itemLocation.id}`)
                .then(() => {
                    this.$store.dispatch('setSuccess', 'Lokationen blev slettet')
                    this.$emit('updated');
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Lokation kunne ikke slettes')
                    console.error(error)
                });
        },
        update(itemLocation, count) {
            if (count && itemLocation.count!==parseInt(count)) {
                window.axios.put(`${this.apiUrl}/${itemLocation.id}`, { count })
                .then(() => {
                    this.$emit('updated');
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Lokationen kunne ikke opdateres')
                    console.error(error)
                });
            }
            this.selectedItemLocationId = null;
        },
        onUpdateKeyUpEnter() {
            this.selectedItemLocationId = null;
        },
        onCloseLocationModal() {
            this.showItemLocationModal = false;
            this.selectedItemLocation = null;
        },
        onOpenLocationModal() {
            this.showItemLocationModal = true
        },
        onCloseProjectModal() {
            this.showItemProjectModal = false;
        },
        onOpenProjectModal() {
            this.showItemProjectModal = true
        },
        onOpenSingleLocation(location) {
            this.selectedItemLocation = location;
            this.onOpenLocationModal();
        },
        onCreated(data) {
            this.$emit('updated', data);
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    margin-bottom: 1rem;
    width: 100%;
}

.count {
    cursor: pointer;
}
.reserved {
    padding-right: 2rem;
}
table tbody tr td:first-child {
    width: 40% !important;
}
table tbody tr td:not(first-child) {
    width: auto !important;
}
.count-width {
    width: 33% !important;
}
</style>
